import { render, staticRenderFns } from "./BirthdayCelebration.vue?vue&type=template&id=bbd04848&scoped=true"
import script from "./BirthdayCelebration.vue?vue&type=script&lang=js"
export * from "./BirthdayCelebration.vue?vue&type=script&lang=js"
import style0 from "./BirthdayCelebration.vue?vue&type=style&index=0&id=bbd04848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd04848",
  null
  
)

export default component.exports